import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { ArrowLeft, ShieldCheck } from 'lucide-react';
import { useAuth } from '../utils/AuthContext';

const SupportAccessBanner = () => {
  const { supportSession, endSupportAccess, user } = useAuth();
  const [now, setNow] = useState(Date.now());
  const [returning, setReturning] = useState(false);
  const banner = useRef(null);
  useEffect(() => {
    if (!supportSession) return undefined;
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, [supportSession]);
  useLayoutEffect(() => {
    if (!supportSession || !banner.current) return undefined;
    const update = () => document.documentElement.style.setProperty('--support-banner-height', `${banner.current.getBoundingClientRect().height}px`);
    update();
    const observer = new ResizeObserver(update);
    observer.observe(banner.current);
    return () => { observer.disconnect(); document.documentElement.style.removeProperty('--support-banner-height'); };
  }, [supportSession]);
  if (!supportSession) return null;
  const seconds = Math.max(0, Math.ceil((Date.parse(supportSession.expiresAt) - now) / 1000));
  const returnToAccount = async () => { setReturning(true); await endSupportAccess(); };
  return (
    <div ref={banner} role="region" aria-label="Support access" className="support-access-banner fixed inset-x-0 z-[80] border-b border-amber-300 bg-primary-800 px-4 py-3 text-white shadow-lg">
      <div className="mx-auto flex max-w-7xl flex-col gap-2 sm:flex-row sm:items-center sm:justify-between sm:gap-3">
        <div className="min-w-0 sm:flex-1"><p className="flex items-center gap-2 text-sm font-semibold"><ShieldCheck size={17} className="shrink-0 text-amber-300" /><span className="min-w-0 flex-1 truncate" title={user?.contactName || supportSession.targetName}>Viewing as {user?.contactName || supportSession.targetName}</span><span className="shrink-0 rounded bg-white/15 px-2 py-0.5 text-xs tabular-nums">{Math.floor(seconds / 60)}:{String(seconds % 60).padStart(2, '0')}</span></p><p className="mt-1 hidden text-xs text-white/85 sm:block">{user?.companyName} · Support activity is excluded from customer reports.</p></div>
        <button type="button" onClick={returnToAccount} disabled={returning} className="inline-flex min-h-11 w-full items-center justify-center gap-2 rounded-lg bg-white px-3 py-2 text-sm font-semibold text-primary-800 hover:bg-amber-50 disabled:opacity-60 sm:w-auto"><ArrowLeft size={17} />{returning ? 'Returning…' : 'Return to my account'}</button>
      </div>
    </div>
  );
};
export default SupportAccessBanner;
